export function uniq<T>(array: T[]): T[] {
  return [...new Set(array)];
}

export const flat = <T>(arr: (T[] | T)[]): T[] => {
  return arr.reduce<T[]>((acc, val) => acc.concat(val), []);
};

export const notEmpty = <TValue>(value: TValue | null | undefined): value is TValue =>
  value !== null && value !== undefined;

export const equal = <T>(firstArray: T, secondArray: T): boolean => {
  return (
    Array.isArray(firstArray) &&
    Array.isArray(secondArray) &&
    firstArray.length === secondArray.length &&
    firstArray.every((value, index) => value === secondArray[index])
  );
};
